export default __webpack_public_path__ + "static/media/03.5edc3323.jpg";